import React, { memo, useState, useEffect, useCallback } from 'react';

import styles from './ItemGame.module.less';
import androidImg from '../../../static/game/smallAndroid.png';
import DLCImg from '../../../static/game/smallDLC.png';
import _LogInView from '../../_LogInView/_LogInView';
import { getSoftType } from '../../../utils/utils';

export default memo(({ soft, topIndex, logInfo }) => {
  const topNum = index => {
    switch (index) {
      case 0:
        return styles.top1;
      case 1:
        return styles.top2;
      case 2:
        return styles.top3;
      case 3:
        return styles.top4;
      case 4:
        return styles.top5;
    }
  };

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);
  const formatPrice = useCallback((num = '0') => {
    return `${parseFloat((parseInt(num) / 100).toFixed(2)) || 0}`;
  }, []);
  const formatPriceZK = useCallback((cu, or) => {
    let c = parseFloat(cu);
    let o = parseFloat(or);
    if (c && o) {
      return `${parseFloat((c / o).toFixed(2)) * 10 || 0}`;
    }
    return '';
  }, []);

  return (
    <_LogInView
      cardData={soft}
      logInfo={{
        ...logInfo,
        softid: soft.androidType === '1' ? soft?.packageName : soft?.softID,
        softType: getSoftType(soft),
      }}
    >
      <div className={styles.item_game}>
        <div className={`top ${topNum(topIndex)}`} />
        <div className="item_game_icon">
          <img src={soft.logoFile} />
          {soft.androidType === '1' && <img className="small_game_icon" src={androidImg} />}
          {soft.installFileType === 1 && soft.androidType !== '1' && (
            <img className="small_game_icon" src={DLCImg} />
          )}
        </div>
        <div className="item_game_info">
          <div className="item_game_title">{soft.softName}</div>
          <div className="item_game_price">
            {soft?.androidType === '3' && soft?.sourceInfo && soft?.sourceInfo?.sellInfo && (
              <div className={`game_price`}>
                {soft?.sourceInfo?.sellInfo?.discount && (
                  <div className="discount_price">
                    <div className="discount_price_info_c">
                      {soft?.sourceInfo?.sellInfo?.discount} 折
                    </div>
                  </div>
                )}
                {soft?.sourceInfo?.sellInfo?.currentPrice ===
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                  <div className={`price_onlg`}>
                    {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                      !soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className={`free`}>免费</div>
                      )}
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      !soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className="price">
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                        </div>
                      )}
                    {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className="price">
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                        </div>
                      )}
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className="price">
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                        </div>
                      )}
                  </div>
                )}
                {soft?.sourceInfo?.sellInfo?.currentPrice !==
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                  <>
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      !soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className="price">
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                        </div>
                      )}
                    {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className="price">
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                        </div>
                      )}
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <>
                          <div className={`price`}>
                            ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                          </div>
                          <div className={`old_price`}>
                            ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                          </div>
                        </>
                      )}
                  </>
                )}
                {/* {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                  soft?.sourceInfo?.sellInfo?.originalPrice && <div className={`free`}>免费</div>} */}
              </div>
            )}

            {soft?.payType === 1 && (
              <div className={`game_price`}>
                {soft?.currentPrice &&
                  soft?.originalPrice &&
                  soft?.currentPrice !== soft?.originalPrice && (
                    <div className="discount_price">
                      <div className="discount_price_info_c">
                        {formatPriceZK(soft?.currentPrice, soft?.originalPrice)} 折
                      </div>
                    </div>
                  )}
                {((!soft?.currentPrice && soft?.originalPrice) ||
                  (soft?.currentPrice && !soft?.originalPrice) ||
                  soft?.currentPrice === soft?.originalPrice) && (
                  <div className={`price`}>
                    ¥{formatPrice(soft?.currentPrice || soft?.originalPrice)}
                  </div>
                )}
                {soft?.currentPrice &&
                  soft?.originalPrice &&
                  soft?.currentPrice !== soft?.originalPrice && (
                    <>
                      <div className={`price`}>¥{formatPrice(soft?.currentPrice)}</div>
                      <div className={`old_price`}>¥{formatPrice(soft?.originalPrice)}</div>
                    </>
                  )}
              </div>
            )}
            {soft?.androidType !== '3' && soft?.payType !== 1 && <div className={`free`}>免费</div>}
          </div>
        </div>
      </div>
    </_LogInView>
  );
});
